<!-- <template>
	<el-container class="register" :class="configStore.electronMode ? 'white-backgroup' : ''">
		<div class="content">
			<el-form :model="dataForm" status-icon :rules="rules" ref="registerForm" class="form" style="margin-top: 50px;margin-bottom: 50px;">
				<div class="title">
					<div>注册账号</div>
				</div>
				<el-form-item v-if="dataForm.mode == 'phone'" prop="phone">
					<el-input v-model="dataForm.phone" autocomplete="off" placeholder="手机号码"></el-input>
				</el-form-item>
				<el-form-item v-show="dataForm.mode == 'phone'" prop="code">
					<el-input v-model="dataForm.code" autocomplete="off" placeholder="验证码">
						<div v-if="phoneLockTime > 0" slot="append">{{ `${phoneLockTime}秒后重新获取` }}</div>
						<el-button v-else slot="append" style="color:#3f3fde"
							@click="onLoadSmsCaptcha">获取验证码</el-button>
					</el-input>
				</el-form-item>
				<el-form-item v-if="dataForm.mode == 'email'" prop="email">
					<el-input v-model="dataForm.email" autocomplete="off" placeholder="邮箱"></el-input>
				</el-form-item>
				<el-form-item v-show="dataForm.mode == 'email'" prop="code">
					<el-input v-model="dataForm.code" autocomplete="off" placeholder="验证码">
						<div v-if="emailLockTime > 0" slot="append">{{ `${emailLockTime}秒后重新获取` }}</div>
						<el-button v-else slot="append" style="color:#3f3fde"
							@click="onLoadMailCaptcha">获取验证码</el-button>
					</el-input>
				</el-form-item>
				<el-form-item prop="userName">
					<el-input type="userName" v-model="dataForm.userName" autocomplete="off" maxlength="20"
						placeholder="用户名(登录使用)"></el-input>
				</el-form-item>
				<el-form-item prop="nickName">
					<el-input type="nickName" v-model="dataForm.nickName" autocomplete="off" maxlength="20"
						placeholder="昵称"></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input type="password" v-model="dataForm.password" autocomplete="off" maxlength="20"
						placeholder="密码"></el-input>
				</el-form-item>
				<el-form-item prop="confirmPassword">
					<el-input type="password" v-model="dataForm.confirmPassword" autocomplete="off"
						placeholder="确认密码"></el-input>
				</el-form-item>
				<el-form-item style="margin: 0 auto;margin-top: 30px;">
					<el-button type="primary" @click="submitForm()" style="height: 40px;width: 150px;margin-right: 30px;">注册</el-button>
					<el-button @click="resetForm()" style="height: 40px;width: 150px;background-color: red;color: white;margin-left: 30px;">清空</el-button>
					<div class="to-login" style="margin-top: 30px;">
						<router-link to="/login">已有账号? 去登录</router-link>
					</div>
				</el-form-item>
			</el-form>
			<el-divider >其他注册方式</el-divider>
			<div class="other-mode">
				<div v-for="(mode) in config.mode" :key="mode">
					<div class="reg-mode" :class="mode == dataForm.mode ? 'active' : ''" @click="switchMode(mode)">
						<span class="icon iconfont " :class="'icon-' + mode"></span>
						<span class="mode-text">{{ modeNameMap[mode]
						}}</span>
					</div>
				</div>
			</div>
		</div>
		<icp></icp>
		<captcha-image ref="captchaRef"></captcha-image>
	</el-container>
</template>

<script>
import CaptchaImage from '../components/common/CaptchaImage.vue';
import Icp from '../components/common/Icp.vue'

export default {
	name: "login",
	components: {
		Icp,
		CaptchaImage
	},
	data() {
		var checkPhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入手机号码'));
			}
			const regex = /^1[3-9]\d{9}$/;
			if (!regex.test(value)) {
				return callback(new Error('手机号格式错误'));
			}
			callback();
		};
		var checkEmail = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入邮箱'));
			}
			const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
			if (!regex.test(value)) {
				return callback(new Error('邮箱格式错误'));
			}
			callback();
		};
		var checkUserName = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入用户名'));
			}
			callback();
		};
		var checkNickName = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入昵称'));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入密码'));
			}
			callback();
		};
		var checkConfirmPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入密码'));
			}
			if (value != this.dataForm.password) {
				return callback(new Error('两次密码输入不一致'));
			}
			callback();
		};
		return {
			dataForm: {
				phone: '',
				email: '',
				code: '',
				mode: 'username',
				userName: '',
				nickName: '',
				password: '',
				confirmPassword: ''
			},
			rules: {
				phone: [{
					validator: checkPhone,
					trigger: 'blur'
				}],
				email: [{
					validator: checkEmail,
					trigger: 'blur'
				}],
				userName: [{
					validator: checkUserName,
					trigger: 'blur'
				}],
				nickName: [{
					validator: checkNickName,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}],
				confirmPassword: [{
					validator: checkConfirmPassword,
					trigger: 'blur'
				}]
			},
			showCaptchaImage: false,
			phoneLockTime: 0,
			phoneLockTimer: null,
			emailLockTime: 0,
			emailLockTimer: null,
			modeNameMap: {
				username: "用户名注册",
				phone: "手机号注册",
				email: "邮箱注册"
			}
		};
	},
	methods: {
		submitForm() {
			this.$refs.registerForm.validate((valid) => {
				if (valid) {
					this.$http({
						url: "/register",
						method: 'post',
						data: this.dataForm
					}).then(() => {
						this.$message.success("注册成功!");
					})
				}
			});
		},
		onLoadSmsCaptcha() {
			this.$refs.registerForm.validateField('phone', (valid) => {
				if (valid == '') {
					// 发短信前先验证验证码，防止盗刷
					this.$refs.captchaRef.open((id, code) => {
						// 60s内不允许再次发送
						this.phoneLockTime = 60;
						this.phoneLockTimer && clearInterval(this.phoneLockTimer);
						this.phoneLockTimer = setInterval(() => {
							this.phoneLockTime -= 1;
							if (this.phoneLockTime <= 0) {
								this.phoneLockTimer && clearInterval(this.phoneLockTimer);
							}
						}, 1000)
						// 发送短信
						let data = {
							phone: this.dataForm.phone,
							id: id,
							code: code
						}
						this.$http({
							url: "/captcha/sms/code",
							method: 'post',
							data: data
						}).then(() => {
							this.$message.success("验证码已发送至您的手机，请注意查收")
						})
					});
				}
			})
		},
		onLoadMailCaptcha() {
			this.$refs.registerForm.validateField('email', (valid) => {
				if (valid == '') {
					// 60s内不允许再次发送
					this.emailLockTime = 60;
					this.emailLockTimer && clearInterval(this.emailLockTimer);
					this.emailLockTimer = setInterval(() => {
						this.emailLockTime -= 1;
						if (this.emailLockTime <= 0) {
							this.emailLockTimer && clearInterval(this.emailLockTimer);
						}
					}, 1000)
					// 发送短信
					let data = {
						email: this.dataForm.email,
					}
					this.$http({
						url: "/captcha/mail/code",
						method: 'post',
						data: data
					}).then(() => {
						this.$message.success("验证码已发送至您的邮箱，请注意查收")
					})

				}
			})
		},
		switchMode(mode) {
			this.dataForm.mode = mode;
			this.resetForm();
		},
		resetForm() {
			this.$refs.registerForm.resetFields();
		}
	},
	computed: {
		config() {
			return this.configStore.registration;
		},
	},
	watch: {
		config: {
			handler() {
				this.switchMode(this.config.mode[0]);
			}
		}
	},
	mounted() {
		this.configStore.loadConfig().then(() => {
			if (this.config.mode) {
				this.switchMode(this.config.mode[0]);
			}
		})
		// electron窗口大小
		window.electronAPI && window.electronAPI.sendEvent('resize', {
			width: 400,
			height: 620,
			maximizable: false
		})
	}
}
</script>

<style scoped lang="scss">
.register {
	display: flex;
	justify-content: space-around;
	align-items: center;
	width: 100%;
	height: 100%;
	background: #E8F2FF;

	&.white-backgroup {
		background: white;
	}

	.content {
		width: 420px;
		height: 670px;
		padding: 20px;
		background: white;
		opacity: 0.9;
		box-shadow: 0px 0px 1px #ccc;
		border-radius: 3px;
		overflow: hidden;
		border-radius: 3%;

		.form {
			display: flex;
			flex-direction: column;
			width: 100%;
			height: 480px;
			justify-content: center;

			.title {
				display: flex;
				justify-content: center;
				align-items: center;
				line-height: 50px;
				margin: 10px 0 20px 0;
				font-size: 22px;
				font-weight: 600;
				letter-spacing: 2px;
				text-transform: uppercase;

			}
		}


		.to-login {
			display: flex;
			flex-direction: row-reverse;
			line-height: 40px;
			text-align: left;
			padding-left: 20px;
		}

		.other-mode {
			display: flex;
			justify-content: center;
			align-items: center;

			.reg-mode {
				display: flex;
				padding: 15px 10px;
				cursor: pointer;

				.icon {
					color: var(--im-text-color);
					font-size: 20px;
					margin-right: 2px;
				}

				.mode-text {
					color: var(--im-text-color);
					font-size: var(--im-font-size);
				}

				&.active {
					.mode-text {
						color: var(--im-color-primary);
					}

					.icon {
						color: var(--im-color-primary);
					}
				}
			}
		}
	}
}
</style> -->
<template>
	<el-container class="register" :class="adminConfigStore.electronMode ? 'white-backgroup' : ''">
		<!-- 加载/错误提示 -->
		<div v-if="configLoading" class="loading-indicator">加载注册方式配置...</div>
		<div v-else-if="configError" class="config-error">注册方式配置加载失败，请稍后重试</div>

		<!-- 表单内容 -->
		<div v-else class="content">
			<el-form :model="dataForm" status-icon :rules="rules" ref="registerForm" class="form"
				style="margin-top: 50px;margin-bottom: 50px;">
				<div class="title">
					<div>注册账号</div>
				</div>
				<el-form-item v-if="dataForm.mode == 'phone'" prop="phone">
					<el-input v-model="dataForm.phone" autocomplete="off" placeholder="手机号码"></el-input>
				</el-form-item>
				<el-form-item v-show="dataForm.mode == 'phone'" prop="code">
					<el-input v-model="dataForm.code" autocomplete="off" placeholder="验证码">
						<div v-if="phoneLockTime > 0" slot="append">{{ `${phoneLockTime}秒后重新获取` }}</div>
						<el-button v-else slot="append" style="color:#3f3fde"
							@click="onLoadSmsCaptcha">获取验证码</el-button>
					</el-input>
				</el-form-item>
				<el-form-item v-if="dataForm.mode == 'email'" prop="email">
					<el-input v-model="dataForm.email" autocomplete="off" placeholder="邮箱"></el-input>
				</el-form-item>
				<el-form-item v-show="dataForm.mode == 'email'" prop="code">
					<el-input v-model="dataForm.code" autocomplete="off" placeholder="验证码">
						<div v-if="emailLockTime > 0" slot="append">{{ `${emailLockTime}秒后重新获取` }}</div>
						<el-button v-else slot="append" style="color:#3f3fde"
							@click="onLoadMailCaptcha">获取验证码</el-button>
					</el-input>
				</el-form-item>
				<el-form-item prop="userName" v-if="dataForm.mode == 'username'">
					<el-input type="userName" v-model="dataForm.userName" autocomplete="off" maxlength="20"
						:placeholder="userNameMinimum + ' - 20位用户名(登录使用)'"></el-input>
				</el-form-item>
				<el-form-item prop="nickName">
					<el-input type="nickName" v-model="dataForm.nickName" autocomplete="off" maxlength="20"
						placeholder="昵称"></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input type="password" show-password v-model="dataForm.password" autocomplete="off"
						maxlength="20" placeholder="密码"></el-input>
				</el-form-item>
				<el-form-item prop="confirmPassword">
					<el-input type="password" show-password v-model="dataForm.confirmPassword" autocomplete="off"
						placeholder="确认密码"></el-input>
				</el-form-item>
				<el-form-item style="margin: 0 auto;margin-top: 30px;">
					<el-button type="primary" @click="submitForm()"
						style="height: 40px;width: 150px;margin-right: 30px;">注册</el-button>
					<el-button @click="resetForm()"
						style="height: 40px;width: 150px;background-color: red;color: white;margin-left: 30px;">清空</el-button>
					<div class="to-login" style="margin-top: 30px;">
						<router-link to="/login">已有账号? 去登录</router-link>
					</div>
				</el-form-item>
			</el-form>
			<el-divider v-if="showRegisterMethods">其他注册方式</el-divider>
			<div v-if="showRegisterMethods" class="other-mode">
				<div v-if="needPhoneRegister" class="reg-mode" :class="currentTab == 'phone' ? 'active' : ''"
					@click="switchMode('phone')">
					<span class="icon iconfont icon-phone"></span>
					<span class="mode-text">手机号注册</span>
				</div>
				<div v-if="needUserNameRegister" class="reg-mode" :class="currentTab == 'username' ? 'active' : ''"
					@click="switchMode('username')">
					<span class="icon iconfont icon-username"></span>
					<span class="mode-text">用户名注册</span>
				</div>
				<div v-if="needEmailRegister" class="reg-mode" :class="currentTab == 'email' ? 'active' : ''"
					@click="switchMode('email')">
					<span class="icon iconfont icon-email"></span>
					<span class="mode-text">邮箱注册</span>
				</div>

			</div>
		</div>

		<!-- <icp></icp> -->
		<captcha-image ref="captchaRef"></captcha-image>
	</el-container>
</template>

<script>
	import CaptchaImage from '../components/common/CaptchaImage.vue';
	import Icp from '../components/common/Icp.vue';
	import UAParser from 'ua-parser-js';
	export default {
		name: "login",
		components: {
			Icp,
			CaptchaImage
		},
		data() {
			var checkPhone = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入手机号码'));
				}
				const regex = /^1[3-9]\d{9}$/;
				if (!regex.test(value)) {
					return callback(new Error('手机号格式错误'));
				}
				callback();
			};
			var checkEmail = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入邮箱'));
				}
				const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
				if (!regex.test(value)) {
					return callback(new Error('邮箱格式错误'));
				}
				callback();
			};
			var checkUserName = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入用户名'));
				}
				if (value.length <= Number(this.userNameMinimum - 1)) {
					return callback(new Error('用户名长度为 ' + this.userNameMinimum + ' - 20 位'));
				}
				callback();
			};
			var checkNickName = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入昵称'));
				}
				callback();
			};
			var checkPassword = (rule, value, callback) => {
				if (value === '') {
					return callback(new Error('请输入密码'));
				}
				callback();
			};
			var checkConfirmPassword = (rule, value, callback) => {
				if (value === '') {
					return callback(new Error('请输入密码'));
				}
				if (value != this.dataForm.password) {
					return callback(new Error('两次密码输入不一致'));
				}
				callback();
			};
			return {
				dataForm: {
					phone: '',
					email: '',
					code: '',
					mode: 'username',
					userName: '',
					nickName: '',
					password: '',
					confirmPassword: ''
				},
				rules: {
					phone: [{
						validator: checkPhone,
						trigger: 'blur'
					}],
					email: [{
						validator: checkEmail,
						trigger: 'blur'
					}],
					userName: [{
						validator: checkUserName,
						trigger: 'blur'
					}],
					nickName: [{
						validator: checkNickName,
						trigger: 'blur'
					}],
					password: [{
						validator: checkPassword,
						trigger: 'blur'
					}],
					confirmPassword: [{
						validator: checkConfirmPassword,
						trigger: 'blur'
					}]
				},
				currentTab: '',
				showCaptchaImage: false,
				phoneLockTime: 0,
				phoneLockTimer: null,
				emailLockTime: 0,
				emailLockTimer: null,
				userNameMinimum: null,
				modeNameMap: {
					username: "用户名注册",
					phone: "手机号注册",
					email: "邮箱注册"
				},
				configLoading: true,
				configError: false,
				needPhoneRegister: false,
				needEmailRegister: false,
				needUserNameRegister: false,
				loginForm: {
					terminal: this.$enums.TERMINAL_TYPE.WEB,
					userName: '',
					password: '',
					clientOs: ''
				},
			};
		},
		methods: {
			// submitForm() {
			// 	this.$refs.registerForm.validate((valid) => {
			// 		if (valid) {
			// 			const payload = { ...this.dataForm };
			// 			if (payload.mode === 'phone') {
			// 				payload.userName = payload.phone;
			// 			} else if (payload.mode === 'email') {
			// 				payload.userName = payload.email;
			// 			}
			// 			const channelCode = localStorage.getItem('channelCode');
			// 			if (channelCode) {
			// 				payload.channelCode = channelCode;
			// 			}
			// 			this.$http({
			// 				url: "/register",
			// 				method: 'post',
			// 				data: payload
			// 			}).then(() => {
			// 				this.$message.success("注册成功!");
			// 				const parser = new UAParser();
			// 				const os = parser.getOS();
			// 				const cpu = parser.getCPU();
			// 				this.loginForm.terminal = this.$enums.TERMINAL_TYPE.WEB;
			// 				this.loginForm.userName = payload.userName;
			// 				this.loginForm.password = payload.password;
			// 				this.loginForm.clientOs = os.name + " " + os.version + " " + cpu.architecture;
			// 				this.$http({
			// 					url: "/login",
			// 					method: 'post',
			// 					data: this.loginForm
			// 				}).then((data) => {
			// 					localStorage.setItem('isAutoLogin', true);
			// 					// 保存密码到
			// 					localStorage.setItem('username', this.loginForm.userName);
			// 					localStorage.setItem('password', this.loginForm.password);
			// 					// localStorage
			// 					sessionStorage.setItem("accessToken", data.accessToken);
			// 					sessionStorage.setItem("refreshToken", data.refreshToken);
			// 					this.$message.success("登录成功");
			// 					this.$router.push("/home/chat");
			// 				}).finally(() => {
			// 					this.loading = false
			// 				})

			// 			});
			// 		}
			// 	});
			// },
			submitForm() {
				this.$refs.registerForm.validate((valid) => {
					if (!valid) return;

					const payload = {
						...this.dataForm
					};
					if (payload.mode === 'phone') {
						payload.userName = payload.phone;
					} else if (payload.mode === 'email') {
						payload.userName = payload.email;
					}
					
					const channelCode = localStorage.getItem('channelCode');
					if (channelCode) {
						payload.channelCode = channelCode;
					}
					// 用户名注册：先图形验证码，再提交
					if (payload.mode === 'username') {
						if (!this.$refs.captchaRef || !this.$refs.captchaRef.open) {
							this.$message.error('验证码组件不可用');
							return;
						}
						let enable = this.adminConfigStore.getConfigValueByKey('im.enable.code');
						if (enable === 'true') {
							this.$refs.captchaRef.open((id, code) => {
								payload.id = id;
								payload.code = code;
								this._doRegister(payload);
							});
						} else {
							this._doRegister(payload);
						}

						return;
					}

					// 手机/邮箱注册：直接提交
					if (payload.mode === 'phone' || payload.mode === 'email') {
						this._doRegister(payload);
					}
				});
			},

			_doRegister(payload) {
				this.$http({
					url: "/register",
					method: 'post',
					data: payload
				}).then(() => {
					this.$message.success("注册成功!");

					const parser = new UAParser();
					const os = parser.getOS();
					const cpu = parser.getCPU();

					this.loginForm.terminal = this.$enums.TERMINAL_TYPE.WEB;
					this.loginForm.userName = payload.userName;
					this.loginForm.password = payload.password;
					this.loginForm.clientOs = (os.name || '') + " " + (os.version || '') + " " + (cpu
						.architecture || '');

					this.$http({
						url: "/login",
						method: 'post',
						data: this.loginForm
					}).then((data) => {
						localStorage.setItem('isAutoLogin', true);
						localStorage.setItem('username', this.loginForm.userName);
						localStorage.setItem('password', this.loginForm.password);
						sessionStorage.setItem("accessToken", data.accessToken);
						sessionStorage.setItem("refreshToken", data.refreshToken);
						this.$message.success("登录成功");
						this.$router.push("/home/chat");
					}).finally(() => {
						this.loading = false;
					});
				});
			},

			onLoadSmsCaptcha() {
				this.$refs.registerForm.validateField('phone', (valid) => {
					if (valid === '') {
						// 读取配置
						let enable = this.adminConfigStore.getConfigValueByKey('im.enable.code');

						// 如果配置开启了图形验证码
						if (enable === 'true') {
							this.$refs.captchaRef.open((id, code) => {
								const data = {
									phone: this.dataForm.phone,
									id: id,
									code: code,
									isRegister: true
								};
								this._sendSmsCode(data);
							});
						} else {
							// 不需要图形验证码，直接发送短信
							const data = {
								phone: this.dataForm.phone,
								isRegister: true
							};
							this._sendSmsCode(data);
						}
					}
				});
			},

			// 抽出公共发送逻辑
			_sendSmsCode(data) {
				this.$http({
					url: "/captcha/sms/code",
					method: "post",
					data: data
				}).then((res) => {
					this.phoneLockTime = 60;
					this.phoneLockTimer && clearInterval(this.phoneLockTimer);
					this.phoneLockTimer = setInterval(() => {
						this.phoneLockTime -= 1;
						if (this.phoneLockTime <= 0) clearInterval(this.phoneLockTimer);
					}, 1000);
					if (res) this.dataForm.code = res; // 测试验证码回显
					this.$message.success("验证码已发送至您的手机，请注意查收");
				});
			},
			onLoadMailCaptcha() {
				this.$refs.registerForm.validateField('email', (valid) => {
					if (valid == '') {
						let data = {
							email: this.dataForm.email,
							isRegister: true
						};
						this.$http({
							url: "/captcha/mail/code",
							method: 'post',
							data: data
						}).then((res) => {
							this.emailLockTime = 60;
							this.emailLockTimer && clearInterval(this.emailLockTimer);
							this.emailLockTimer = setInterval(() => {
								this.emailLockTime -= 1;
								if (this.emailLockTime <= 0) clearInterval(this.emailLockTimer);
							}, 1000);
							this.$message.success("验证码已发送至您的邮箱，请注意查收");
						});
					}
				});
			},
			switchMode(mode) {
				this.dataForm.mode = mode;
				this.currentTab = mode;
				this.resetForm();
			},
			async loadConfig() {
				this.configLoading = true;
				this.configError = false;
				try {
					this.adminConfigStore.loadAdminConfig()
						.then(() => {
							return Promise.all([
								this.adminConfigStore.getConfigValueByKey('im.user.minimum.length'),
								this.adminConfigStore.getConfigValueByKey('im.email.registration'),
								this.adminConfigStore.getConfigValueByKey('im.phone.registration'),
								this.adminConfigStore.getConfigValueByKey('im.userName.registration')
							]);
						})
						.then(([min, emailReg, phoneReg, userNameReg]) => {
							// 最好转成数字，别到处用字符串比较
							this.userNameMinimum = Number(min) || 0;
							this.minimum = Number(min) || 0;

							this.needEmailRegister = emailReg === 'true';
							this.needPhoneRegister = phoneReg === 'true';
							this.needUserNameRegister = userNameReg === 'true';

							// 按优先顺序（phone > email > username）
							const available = [{
									key: 'phone',
									ok: this.needPhoneRegister
								},
								{
									key: 'email',
									ok: this.needEmailRegister
								},
								{
									key: 'username',
									ok: this.needUserNameRegister
								}
							].filter(m => m.ok);

							if (available.length > 0) {
								this.dataForm.mode = available[0].key;
								this.currentTab = available[0].key;
							} else {
								// 全部关闭则回落到手机号
								this.needPhoneRegister = true;
								this.dataForm.mode = 'phone';
								this.currentTab = 'phone';
							}
						})
				} catch {
					this.configError = true
					// 失败时默认都开
					this.minimum = 6
					this.needEmailRegister = true
					this.needPhoneRegister = true
					this.needUserNameRegister = true
					this.currentTab = 'phone'
				} finally {
					this.configLoading = false
				}
			},
			resetForm() {
				this.$refs.registerForm.resetFields();
			}
		},
		computed: {
			showRegisterMethods() {
				return [this.needPhoneRegister, this.needEmailRegister, this.needUserNameRegister].filter(v => v).length >
					1;
			}
		},
		mounted() {
			this.loadConfig();
			window.electronAPI && window.electronAPI.sendEvent('resize', {
				width: 400,
				height: 700,
				maximizable: false
			});
			window.electronAPI && window.electronAPI.sendEvent('center');
		}
	};
</script>

<style scoped lang="scss">
	.register {
		display: flex;
		justify-content: space-around;
		align-items: center;
		width: 100%;
		height: 100%;
		background: #E8F2FF;

		&.white-backgroup {
			background: white;
		}

		.content {
			width: 420px;
			height: 670px;
			padding: 20px;
			background: white;
			opacity: 0.9;
			box-shadow: 0px 0px 1px #ccc;
			overflow: hidden;
			border-radius: 3%;

			.form {
				display: flex;
				flex-direction: column;
				width: 100%;
				height: 480px;
				justify-content: center;

				.title {
					display: flex;
					justify-content: center;
					align-items: center;
					line-height: 50px;
					margin: 10px 0 20px 0;
					font-size: 22px;
					font-weight: 600;
					letter-spacing: 2px;
					text-transform: uppercase;
				}
			}

			.to-login {
				display: flex;
				flex-direction: row-reverse;
				line-height: 40px;
				text-align: left;
				padding-left: 20px;
			}

			.other-mode {
				display: flex;
				justify-content: center;
				align-items: center;

				.reg-mode {
					display: flex;
					padding: 15px 10px;
					cursor: pointer;

					.icon {
						color: var(--im-text-color);
						font-size: 20px;
						margin-right: 2px;
					}

					.mode-text {
						color: var(--im-text-color);
						font-size: var(--im-font-size);
					}

					&.active {
						.mode-text {
							color: var(--im-color-primary);
						}

						.icon {
							color: var(--im-color-primary);
						}
					}
				}
			}
		}
	}

	.loading-indicator,
	.config-error {
		width: 100%;
		text-align: center;
		padding: 20px 0;
		color: #409EFF;
	}
</style>